// extracted by mini-css-extract-plugin
module.exports = {"link":"Link--link--hkChD","quiet":"Link--quiet--1Ebe7","standard":"Link--standard--otcnH","prominent":"Link--prominent--1HBCT"};